import { ConsoleLoggingSink } from './console_logging_sink'

export class PrefixLogger {
  constructor (prefix, sink = null) {
    this.prefix = prefix
    this.sink = sink || new ConsoleLoggingSink()
  }

  debug (...args) {
    this.sink.debug(this.prefix, ...args)
  }

  error (...args) {
    this.sink.error(this.prefix, ...args)
  }

  info (...args) {
    this.sink.info(this.prefix, ...args)
  }

  log (...args) {
    this.sink.log(this.prefix, ...args)
  }

  warn (...args) {
    this.sink.warn(this.prefix, ...args)
  }
}
